export default "__VITE_ASSET__DVDu$h9e__"